function Footer() {
    return (
        <footer className="footer">
            <p>
                © {new Date().getFullYear()} Biggest Book LLC. All rights reserved.
            </p>
        </footer>
    );
}

export default Footer;
